export default __webpack_public_path__ + "static/media/word-cloud_640x360.4eb8d311.jpg";